import { toastr } from 'react-redux-toastr';
import adminUpdateBookingDriverMutation from './adminUpdateBookingDriver.gql';

export default function adminUpdateBookingDriver(bookingId, driverId) {
  return async (dispatch, getState, { client }) => {

    try {
      let errorMessage;
      const mutation = adminUpdateBookingDriverMutation;

      const { data } = await client.mutate({
        mutation,
        variables: {
          bookingId: parseInt(bookingId),
          driverId: driverId
        }
      });

      if (data?.adminUpdateBookingDriver?.status === 200) {
        toastr.success('Success', `Driver has been reassigned successfully.`);
        return {
          status: 200
        };
      } else {
        errorMessage = (data && data.adminUpdateBookingDriver && data.adminUpdateBookingDriver.errorMessage) || "Oops! Something went wrong. Please try again.";
        toastr.error('Error!', errorMessage);
        return {
          status: 400
        };
      }
    } catch (err) {
      console.error(err);
      toastr.error('Error!', 'Something went wrong');
      return {
        status: 400
      };
    }

  }
};
